import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Colors, Typography } from '../../shared/theme/styles.enum';
import { diagonals } from '../../shared/utils/pathConstants';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      flexGrow: 1,
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
      paddingTop: "20vh",
      position: 'relative' as const,
      zIndex: 1,
      '@media (max-width:768px)': {
        paddingTop: '6vh',
      },
    },
    topSection: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      flex: 1,
      position: 'relative' as const,
      zIndex: 1,
    },
    fullHeight: {
      height: "100%"
    },
    header:{
      position:"relative", 
      top:"35vh", 
      marginLeft:"6vw",
      fontSize:"1.6rem",
    },
    paragraph:{
      position:"relative",
      marginLeft:"6vw",
      marginTop:"1.6vh",
      fontSize:"1.2rem",
      '@media (max-width:768px)': {
        marginLeft: 0,
        textAlign: 'center',
        padding: '0 16px',
        fontSize: '1rem',
      },
    },
    logo:{
      maxWidth: '100%',
      height: 'auto',
      '@media (max-width:768px)': {
        margin: '0 auto',
        maxWidth: '70%',
      },
    },
    image: {
      width: '100vw',
      height: '92.7vh',
    },
    title: {
      fontFamily: Typography.FontFamily1,
      fontSize: '2.125rem',
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      textAlign: 'left',
      color: theme.palette.secondary.main,
      margin: '20px 0px',
      textTransform: 'capitalize',
      '@media (max-width:768px)': {
        textAlign: 'center',
        fontSize: '1.75rem',
      },
    },
    container: {
      alignSelf: 'flex-start',
      marginLeft: "60px",
      '@media (max-width:768px)': {
        alignSelf: 'center',
        marginLeft: 0,
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        width: '100%',
        padding: '0 16px',
      },
    },
    iconButton: {
      width: 15,
      height: 18,
      marginRight: 10,
    },
    buttonStyle: {
      borderRadius: 3,
      border: `solid 1px ${theme.palette.secondary.main}`,
      width: 145,
      display: 'flex',
      justifyContent: 'center',
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      padding: 8,
      marginBottom: 10,
      '@media (max-width:768px)': {
        width: 130,
      },
    },
    linkStyle: {
      borderRadius: 3,
      border: `solid 1px ${theme.palette.primary.main}`,
      width: 145,
      display: 'flex',
      justifyContent: 'center',
      color: Colors.White,
      backgroundColor: theme.palette.primary.main,
      cursor: 'pointer',
      padding: 8,
      marginBottom: 10,
      position:"relative",
      textDecoration: 'none',
      '@media (max-width:768px)': {
        width: 130,
      },
    },
    legal: {
      width: '100%',
      padding: '24px 24px 32px',
      borderTop: '1px solid rgba(0, 0, 0, .1)',
      fontSize: '0.7rem',
      lineHeight: 1.6,
      color: Colors.TextGray,
      '@media (max-width:768px)': {
        padding: '16px 16px 24px',
        fontSize: '0.65rem',
      },
    },
    buttonText: {
      fontFamily: Typography.FontFamily2,
      fontSize: Typography.Body,
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
    footerContainer: {
      height: '32.5vh',
      background: `url(${diagonals}) no-repeat`,
      backgroundSize: 'cover',
      display: 'flex',
      justifyContent: 'center',
    },
    footer: {
      fontFamily: Typography.FontFamily2,
      fontSize: Typography.BasicText,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1,
      letterSpacing: 'normal',
      textAlign: 'left',
      color: Colors.TextGray,
      paddingTop: '20vh',
      width: 'fit-content',
    },
  })
);
